module.exports = __webpack_public_path__ + "static/media/clock.18d86486.svg";